import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-exportar-pdf',
  standalone: true,
    imports: [CommonModule],
  templateUrl: './btn-exportar-pdf.component.html',
  styleUrls: ['./btn-exportar-pdf.component.scss'],
})
export class BtnExportarPdfComponent {
  /**
   * Controla se o botão está desabilitado
   */
  @Input() disabled: boolean = false;
  /**
   * Texto do botão
   */
  @Input() label: string = '';
  /**
   * Caminho do ícone
   */
  @Input() icon: string = '';
  /**
   * Evento disparado ao clicar
   */
  @Output() exportar = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.exportar.emit();
    }
  }
}
